import React from 'react'
import styled from 'styled-components';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: minmax(16px, 1fr) [inner-start] minmax(0, 60rem) [inner-end] minmax(16px, 1fr);
    padding: 1rem 0 1rem 0; 

    & > div {
      grid-column: inner; 
      display: flex;
      justify-content: center; 
      align-items: center; 
    }; 
`;

const ComingSoon = () => {
  return (
    <Wrapper>
      <div>
        <h1>Denna sida är under konstruktion...</h1>
      </div>
    </Wrapper>
  )
}

export default ComingSoon
